export default __webpack_public_path__ + "assets/front/scss/editorial.dc760afb7ffb7f9ae2daa6755a3da7fb.css";